import { Field } from "formik";
import React from "react";
import { useRuleFieldSchema } from "containers/Settings/RuleBooks/Schema/schemaContext";
import { withNamespace } from "components/Form/FormikControls";
import { getDataTypeByPath } from "containers/Settings/RuleBooks/Schema/schema";
import {
  FieldValueType,
  FieldValueTypeDisplayNameMap,
} from "containers/Settings/RuleBooks/constants";
import { useFieldSetter } from "hooks";

export interface CountDataSourceField {
  source: "COUNT";
  index: number | "";
  valueType: "integer";
}

interface CountDataSourceProps {
  namespace: string;
  // Array of JSON paths
  options: string[];
  allowFromIndex?: number;
}

export function CountDataSource(props: CountDataSourceProps) {
  const { namespace: ns, options = [], allowFromIndex = null } = props;

  const schema = useRuleFieldSchema();

  const setIndex = useFieldSetter(withNamespace(ns, "criteria_output_index"));

  const areOptionsAvailable = Array.isArray(options) && options.length > 0;

  function onChangeIndex({ target: selectEl }) {
    const { selectedIndex } = selectEl;
    setIndex(
      selectedIndex > -1
        ? selectedIndex
        : // Setting to empty will match the value of the "Select a Criteria" option
          "",
    );
  }

  return (
    <>
      <Field
        as="select"
        className="p-2"
        disabled={!areOptionsAvailable}
        name={withNamespace(ns, "criteria_output_index")}
        onChange={onChangeIndex}
        required
      >
        <option value="" disabled>
          {areOptionsAvailable
            ? "Select a Criteria"
            : "No options are available"}
        </option>
        {options.map((option, index) => {
          const key = `${option}-${index}`;
          return (
            <option
              key={key}
              value={index}
              disabled={
                allowFromIndex !== null ? allowFromIndex <= index : false
              }
            >
              {getDataTypeByPath(schema, option)?.plural || option} in criteria{" "}
              {index + 1}
            </option>
          );
        })}
      </Field>{" "}
      ({FieldValueTypeDisplayNameMap[FieldValueType.INTEGER]})
    </>
  );
}
